import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd25defe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guardian-import-container" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "main-header" }
const _hoisted_4 = { class: "main-body" }
const _hoisted_5 = { class: "controls-area" }
const _hoisted_6 = { class: "controls-area-right" }
const _hoisted_7 = { class: "message-area" }
const _hoisted_8 = { class: "message-area__row" }
const _hoisted_9 = { class: "message-area__row margin-top" }
const _hoisted_10 = {
  key: 0,
  class: "data-area saving"
}
const _hoisted_11 = {
  key: 1,
  class: "data-area table-wrap"
}
const _hoisted_12 = {
  key: 2,
  class: "data-area preview"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-text" }, "Preview", -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GuardianSubPageHeading = _resolveComponent("GuardianSubPageHeading")!
  const _component_UploadArea = _resolveComponent("UploadArea")!
  const _component_ConfirmImportButton = _resolveComponent("ConfirmImportButton")!
  const _component_LoadingBlock = _resolveComponent("LoadingBlock")!
  const _component_GuardianListTable = _resolveComponent("GuardianListTable")!
  const _component_GuardianColumnsSelect = _resolveComponent("GuardianColumnsSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_GuardianSubPageHeading, {
          class: "page-heading",
          "sub-label": "Guardian Import",
          "main-page-heading-link-path": "/guardian",
          "on-click-back": _ctx.onClickBack
        }, null, 8, ["on-click-back"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_UploadArea, {
            class: "upload-area",
            "main-text": "ここにCSVファイルをドロップ",
            "button-text": "CSVファイルを選択",
            accept: "text/csv",
            "on-select-file": _ctx.onSelectFile,
            "on-unselect-file": _ctx.onUnselectFileInternal
          }, null, 8, ["on-select-file", "on-unselect-file"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.googleMailDisplayName) + "、" + _toDisplayString(_ctx.childrenDisplayName) + "は更新できません。", 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.childrenDisplayName) + "を変更するには、" + _toDisplayString(_ctx.studentDisplayName) + "編集画面から" + _toDisplayString(_ctx.guardianDisplayName) + "を選択してください。", 1)
            ]),
            _createVNode(_component_ConfirmImportButton, {
              class: "confirm-button",
              enabled: _ctx.guardians.hasFreshData && !_ctx.saving,
              "on-click": _ctx.onConfirmImport
            }, null, 8, ["enabled", "on-click"])
          ])
        ]),
        (_ctx.saving)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_LoadingBlock)
            ]))
          : (_ctx.guardians.hasData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_GuardianListTable, {
                  class: "guardian-list-table",
                  "horizontal-margin": 24,
                  guardians: _ctx.guardians.data,
                  "column-visibility": _ctx.columnVisibility,
                  "link-enabled": false
                }, null, 8, ["guardians", "column-visibility"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      ])
    ]),
    _createVNode(_component_GuardianColumnsSelect, {
      class: "columns-select",
      "column-visibility": _ctx.columnVisibility,
      open: _ctx.isColumnSelectOpen,
      "on-click-collapse-button": _ctx.toggleColumnSelectVisibility,
      "on-change-column-visibility": _ctx.onChangeColumnVisibility
    }, null, 8, ["column-visibility", "open", "on-click-collapse-button", "on-change-column-visibility"])
  ]))
}